import { RecipientType } from '../enums/recipient-type.enum';
import { DistributionRecipientModel } from './distribution-recipient-model';

export class RecipientGroup {
    type: RecipientType;
    label: string;
    total: number = 0;
    recipients: DistributionRecipientModel[] = [];
    emailRecipients: string[] = [];
    tooltip?: string;

    constructor (type: RecipientType, label: string) {
        this.type = type;
        this.label = label;
    }

    equals(other: RecipientGroup) {
        if (this.recipients.length !== other.recipients.length) {
            return false;
        }
        if (this.emailRecipients.length !== other.emailRecipients.length) {
            return false;
        }

        if (this.emailRecipients.length !== 0) {
            for (const emailRecipient of this.emailRecipients) {
                if (other.emailRecipients.indexOf(emailRecipient) === -1) {
                    return false;
                }
            }
        }

        if (this.recipients.length !== 0) {
            for (const recipient of this.recipients) {
                if (!other.recipients.find(x => x.equals(recipient))) {
                    return false;
                }
            }
        }
        return true;
    }
}
